import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Rodape extends Component {

  constructor(props) {
    super(props);
  }

  data_atual = new Date();

  render() {
    return (
      <footer className="footer-3 footer-topbar light page-section-pt">
        <div className="container">
          <div className="row top">
            <div className="col-lg-3 col-md-12">
              <img
                className="img-fluid"
                id="logo_footer_dark"
                src="images/logo-dark.png"
                alt=""
              />
            </div>

            <div className="col-lg-4 col-md-12">
              <div className="social text-lg-right text-center">
                <ul>
                  <li>
                    <a href="https://www.facebook.com/D%C3%B3se-Car-Veiculos-205103293711543/">
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/dose_car/">
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://api.whatsapp.com/send?phone=5534999619292&text=Ol%C3%A1%2C%20vi%20um%20an%C3%BAncio%20em%20seu%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20o%20ve%C3%ADculo">
                      <i className="fa fa-whatsapp"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-5 col-md-12">
              <div className="about-content">
                <h6 className="text-black">Sobre nós</h6>
                <p className="text-gray">
                  Com uma postura personalizada no mercado de veículos, a Dose Car Veículos 
                  traz um novo conceito de trabalho e atendimento, visando oferecer sempre o 
                  melhor aos seus clientes. A empresa – que nasceu através de uma paixão por 
                  automóveis – atua nos seguimentos de veículos novos e seminovos 
                  de todas as marca.
                </p>
              </div>
            </div>
            <div className="col-lg-7 col-md-12">
              <h6 className="text-black">Informações da loja</h6>
              <div className="usefull-link">
                <div className="row">
                  <div className="col-md-4 footer_info">
                    <ul>
                      <li>
                        <a href="https://www.google.com/maps/place/D%C3%B3se+Car/@-19.0015182,-46.308528,17z/data=!4m5!3m4!1s0x94ae0fbb19d50cbf:0x5aa212d510a5332a!8m2!3d-19.0015182!4d-46.3063393">
                          <i className="fa fa-map-marker"></i>
                          Av. João Batista da Silva, 307 - Juscelino Kubitschek (JK), Carmo do Paranaíba - MG, CEP 38840-000
                        </a>
                      </li>
                      {/* <li>
                        <a href="#">
                          <i className="fa fa-phone"></i>
                          (34) 3225-5990
                        </a>
                      </li> */}
                      <li>
                        <a href="https://api.whatsapp.com/send?phone=5534999619292&text=Ol%C3%A1%2C%20vi%20um%20an%C3%BAncio%20em%20seu%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20o%20ve%C3%ADculo">
                          <i className="fa fa-whatsapp"></i>
                          (34) 9 9961-9292
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa fa-envelope-o"></i>
                          contato@dosecar.com.br
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <div className="text-lg-left text-center">
                  <p>
                    © Copyright 2021 Dose Car Veículos | Todos os direitos reservados.
                    <a href="https://intermedioveiculos.com.br/" target="_blank"
                    > Intermédio Veículos Marketing Digital</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

    );
  }
}

function retiraMascara(value, type = "texto") {
  var numero = '';
  if (value !== undefined) {
    numero = value.replace('_', '');
    if (type === "link") {
      numero = numero.replace('(', '').replace(')', '').replace('-', '').replace(' ', '');
    }
  }
  return numero;
}

export default Rodape;